export default __webpack_public_path__ + "static/media/close-icon.bb314784.svg";